import viewsPages from './views-pages';
import pages from './pages';
import { NavItemType } from 'types';

// ==============================|| PAGES ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  // items: [samplePage, pages],
  items: [viewsPages, pages],
};

export default menuItems;
